<!--
  @component
  Generates an SVG area shape using the `area` function from [d3-shape](https://github.com/d3/d3-shape).
 -->
<script>
  import { line, curveMonotoneX, curveLinear } from 'd3-shape';
  import { getContext } from 'svelte';
	import { tweened } from 'svelte/motion';
  const { data, xGet, yGet } = getContext('LayerCake');

  /** @type {String} [stroke='#ab00d6'] - The shape's fill color. This is technically optional because it comes with a default value but you'll likely want to replace it with your own color. */
  export let stroke = '#ab00d6';


  export let smooth = false;
  export let animated = false;

  const dataTweened = tweened($data, {
		duration: animated ? 400 : 0,
  });

  $: dataTweened.set($data)

  $: pathGenerator = line()
    .x($xGet)
    .y($yGet)
    .curve(smooth ? curveMonotoneX : curveLinear);

  $: path = pathGenerator($dataTweened);




  /*
  $: path = 'M' + $data
    .map(d => {
      return $xGet(d) + ',' + $yGet(d);
    })
    .join('L');
  */
</script>

<path class='path-line' d='{path}' {stroke}></path>

<style>
  .path-line {
    fill: none;
    stroke-linejoin: round;
    stroke-linecap: round;
    stroke-width: 2;
  }
</style>
